module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "Great Notley East",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://great-notley-test.netlify.app/' : 'https://greatnotleyeast.co.uk',

    base: {
        "contact_address": "Great Notley East, Camargue, Eagle Tower, Cheltenham, GL50 1TA",
        "contact_number": "0800 860 6256",
        "contact_email": "info@greatnotleyeast.co.uk"
    },

    meta: {
        "defaultSocialImage": "/assets/images/social.jpg",
        "author": "Great Notley East",
        "description": "",
        "gtag": "G-8LT19ZKP3Q",
        "gtm": "GTM-WS4S447"
    },

    form: {
        "contact": {
            "catcher_id": "48e4eaa24b25b79de324d620d3c7b633",
            "recaptcha": "6LfCNrYUAAAAAOW8mR1JjCFiVHQsv0F1pNjOpP6b",
            "honeypot": "76cd9d0fbde6e8af2bcbe5a33fc0be9c"
        },
        "feedback": {
            "catcher_id": "",
            "recaptcha": "6LfoYYMcAAAAALxFMwkuWGRhDqZ55MK5CIuMOYn9",
            "honeypot": ""
        }
    },

    consultation: {
        "feedback_active": false,
        "start_datetime": "",
        "end_datetime": "",

        themes: {
            1: {
                "name": "Our Vision",
                "icon": "our_vision"
            },
            2: {
                "name": "Employment",
                "icon": "employment"
            },
            3: {
                "name": "Routes",
                "icon": "routes"
            },
            4: {
                "name": "Community",
                "icon": "community"
            },
            5: {
                "name": "Other Comments",
                "icon": "uncategorised"
            }
        }
    },

    hasMap: false,

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? 'https://great-notley-map.jfd-test.co.uk' : 'https://feedback.greatnotleyeast.co.uk',


    // Bugsnag API Key
    bugsnagApiKey: '35dcdccd2b4ee7dc198c7c53b88e1f55'
};